"use client";

import { c as _c } from "react/compiler-runtime";
import { useFeaturesHospitalStore } from '@/features/hospital/model/store';
import { Typography } from '@/shared/ui/atoms';
import { CustomButton } from '@/shared/ui/molecules';
import { useQueryHospitalSubjectsAnalysis } from '@/entities/hospital/hooks/queries';
import { useQueryHospitalReviewAnalysis } from '@/entities/hospital/hooks/queries';
import { useEffect, useRef } from 'react';
import { useHospitalOriginId } from "@/entities/hospital/model/hospital-origin-id";
import { useLocale } from "next-intl";
import { getHospitalAnalysisDisplayLabel } from "@/entities/hospital/lib/analysis-label-localization";
const ReviewFilterModalBody = () => {
  const $ = _c(18);
  const scrollRef = useRef(null);
  const locale = useLocale();
  const hospitalOriginId = useHospitalOriginId();
  const {
    selectedReviewFilterTab,
    selectedSubjectFilter,
    setSelectedSubjectFilter,
    selectedDetailFilter,
    setSelectedDetailFilter
  } = useFeaturesHospitalStore();
  const {
    data: t0
  } = useQueryHospitalSubjectsAnalysis(hospitalOriginId);
  const subjectsAnalysis = t0 === undefined ? [] : t0;
  const {
    data: t1
  } = useQueryHospitalReviewAnalysis(hospitalOriginId);
  const reviewAnalysis = t1 === undefined ? [] : t1;
  let t2;
  if ($[0] !== locale) {
    t2 = item => {
      const displayTreatment = getHospitalAnalysisDisplayLabel(item.treatment, locale);
      return displayTreatment ? [{
        ...item,
        displayTreatment
      }] : [];
    };
    $[0] = locale;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const displaySubjectsAnalysis = subjectsAnalysis.flatMap(t2);
  let t3;
  if ($[2] !== locale) {
    t3 = major => {
      const displayMajorCategory = getHospitalAnalysisDisplayLabel(major.majorCategory, locale);
      if (!displayMajorCategory) {
        return [];
      }
      const items = major.items.flatMap(minor => {
        const displayMinorCategory = getHospitalAnalysisDisplayLabel(minor.minorCategory, locale);
        return displayMinorCategory ? [{
          ...minor,
          displayMinorCategory
        }] : [];
      });
      return items.length > 0 ? [{
        ...major,
        displayMajorCategory,
        items
      }] : [];
    };
    $[2] = locale;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  const displayReviewAnalysis = reviewAnalysis.flatMap(t3);
  let t4;
  if ($[4] !== selectedSubjectFilter) {
    t4 = treatment => selectedSubjectFilter === treatment ? "border-primary-700 bg-primary-700 before:content-[''] before:absolute before:top-1/2 before:left-1/2 before:-translate-x-1/2 before:-translate-y-1/2 before:w-2 before:h-2 before:rounded-full before:bg-gray-200" : "border-gray-200 bg-white";
    $[4] = selectedSubjectFilter;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  const getRadioOptionButtonClassName = t4;
  let t5;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = () => {
      scrollRef.current?.scrollTo(0, 0);
    };
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  let t6;
  if ($[7] !== selectedReviewFilterTab) {
    t6 = [selectedReviewFilterTab];
    $[7] = selectedReviewFilterTab;
    $[8] = t6;
  } else {
    t6 = $[8];
  }
  useEffect(t5, t6);
  if (selectedReviewFilterTab === "treatmentCase") {
    let t7;
    if ($[9] !== getRadioOptionButtonClassName || $[10] !== selectedSubjectFilter || $[11] !== setSelectedSubjectFilter) {
      t7 = (item_0, index) => <CustomButton key={`treatment-case-item-${index}`} className="flex items-center gap-2 py-3" onClick={() => setSelectedSubjectFilter(item_0.treatment)}><span className={`relative w-6 h-6 ${getRadioOptionButtonClassName(item_0.treatment)} border-[2px] rounded-full inline-block`} /><Typography size={16} lineHeight={22} className={`text-gray-600 ${selectedSubjectFilter === item_0.treatment && "font-semibold"}`}>{item_0.displayTreatment}</Typography></CustomButton>;
      $[9] = getRadioOptionButtonClassName;
      $[10] = selectedSubjectFilter;
      $[11] = setSelectedSubjectFilter;
      $[12] = t7;
    } else {
      t7 = $[12];
    }
    return <div ref={scrollRef} className="px-3 pt-5 pb-[72px] overflow-y-auto">{displaySubjectsAnalysis.map(t7)}</div>;
  }
  const t7 = "flex flex-col gap-5 px-4 pt-6 pb-[72px] overflow-y-auto";
  let t8;
  if ($[13] !== selectedDetailFilter || $[14] !== setSelectedDetailFilter) {
    t8 = (major_0, index_0) => <div key={`detail-item-${index_0}`} className="flex flex-col gap-3"><Typography size={14} className="text-start font-bold text-gray-800">{major_0.displayMajorCategory}</Typography><div className="flex flex-wrap gap-x-1 gap-y-3">{major_0.items.map((minorCategory, optionIndex) => {
          const isSelected = selectedDetailFilter.minor === minorCategory.minorCategory && selectedDetailFilter.major === major_0.majorCategory;
          return <label key={`detail-option-${major_0.majorCategory}-${optionIndex}`} className={`inline-flex w-fit cursor-pointer items-center rounded-full border py-2 px-5 transition-colors ${isSelected ? "border-primary-500 bg-primary-50" : "border-gray-200 bg-white"}`}><input type="radio" name={`detail-option-group-${major_0.majorCategory}`} className="sr-only" checked={isSelected} onChange={() => setSelectedDetailFilter({
              major: major_0.majorCategory,
              minor: minorCategory.minorCategory
            })} /><Typography size={14} lineHeight={22} className={isSelected ? "font-semibold text-primary-600" : "font-medium text-gray-800"}>{minorCategory.displayMinorCategory}</Typography></label>;
        })}</div></div>;
    $[13] = selectedDetailFilter;
    $[14] = setSelectedDetailFilter;
    $[15] = t8;
  } else {
    t8 = $[15];
  }
  const t9 = displayReviewAnalysis.map(t8);
  let t10;
  if ($[16] !== t9) {
    t10 = <div ref={scrollRef} className={t7}>{t9}</div>;
    $[16] = t9;
    $[17] = t10;
  } else {
    t10 = $[17];
  }
  return t10;
};
export default ReviewFilterModalBody;